console.log('custom js loaded')


function initEbookSlider(){

const slider=document.querySelector('.slide-ebook-blog');

if(!slider || slider.dataset.loaded) return;

if(typeof Swiper === 'undefined'){
 setTimeout(initEbookSlider,500);
 return;
}

slider.dataset.loaded='true';

slider.classList.add('swiper');

const wrapper=document.createElement('div');
wrapper.className='swiper-wrapper';

const slides=[...slider.querySelectorAll('.promo-img')];

slides.forEach(slide=>{
 slide.classList.add('swiper-slide');
 wrapper.appendChild(slide);
});

slider.appendChild(wrapper);


// arrows inject
const next=document.createElement('div');
next.className='swiper-button-next';

const prev=document.createElement('div');
prev.className='swiper-button-prev';

slider.appendChild(next);
slider.appendChild(prev);


new Swiper('.slide-ebook-blog',{
 loop:true,
 slidesPerView:1,
 spaceBetween:0,

 navigation:{
   nextEl:'.swiper-button-next',
   prevEl:'.swiper-button-prev'
 }

});

}

initEbookSlider();


/* judgeme start */ 

// $(window).on('load', function() {
// })
function judgeMeRev() {

  const widget = document.querySelector('.jdgm-rev-widg');
  if (!widget) return;

  // Counts
  const reviewCount = widget.getAttribute('data-number-of-reviews');
  const questionCount = widget.getAttribute('data-number-of-questions');

  const reviewCountEl = document.querySelector('.review-and-qa-count .review-count');
  const qaCountEl = document.querySelector('.review-and-qa-count .qa-count');

  if (reviewCount && reviewCountEl) {
    reviewCountEl.textContent = reviewCount;
  }

  if (questionCount && qaCountEl) {
    qaCountEl.textContent = questionCount;
  }


  // Write button
  document.querySelectorAll('.write-btn.btn').forEach(btn => {

    if(btn.dataset.bound) return;
    btn.dataset.bound='true';

    btn.addEventListener('click', function(){
      document.querySelector('.jdgm-write-rev-link')?.click();
      document.querySelector('.jdgm-form')?.scrollTo({
        top:0,
        behavior:'smooth'
      });
    });

  });


  // Question button
  document.querySelectorAll('.question-btn.btn').forEach(btn => {

    if(btn.dataset.bound) return;
    btn.dataset.bound='true';

    btn.addEventListener('click', function(){
      document.querySelector('.jdgm-ask-question-btn')?.click();
      document.querySelector('.jdgm-form')?.scrollTo({
        top:0,
        behavior:'smooth'
      });
    });

  });



  document.querySelectorAll('.jdgm-rev__icon').forEach(el=>{
    el.innerHTML='<img src="https://cdn.shopify.com/s/files/1/0407/0830/9157/files/user1.png?v=1718987663" width="40" height="40" alt="User">';
  });



  document.querySelectorAll('.jdgm-rev__author-wrapper').forEach(el=>{
    const profile = el.closest('.jdgm-rev__header')
      ?.querySelector('.jdgm-row-profile');

    if(profile){
      profile.after(el);
    }
  });



  document.querySelectorAll('.jdgm-rev__custom-form').forEach(el=>{
    const rating = el.closest('.jdgm-rev')
      ?.querySelector('.jdgm-rev__rating');

    if(rating){
      rating.after(el);
    }
  });



  document.querySelector('.reviews-loader')?.classList.add('hide');
  document.querySelector('.reviews_tabs')?.classList.remove('hide');

  const reviewWrap=document.getElementById('judgeme_product_reviews');
  if(reviewWrap){
    reviewWrap.style.display='block';
  }



  document.querySelectorAll('.jdgm-rev__custom-form').forEach(form=>{

    form.querySelectorAll('.jdgm-rev__cf-ans').forEach(ans=>{

      const title=ans.querySelector('.jdgm-rev__cf-ans__title');
      const txt=title?.textContent.trim();

      if(txt==='Age:' || txt==='Gender:'){
        ans.classList.remove('hide');
      }else{
        ans.classList.add('hide');
      }

    });

  });



  document.querySelectorAll('.jdgm-row-search').forEach(search=>{

    if(!search.querySelector('.keyword-title')){
      const h2=document.createElement('h2');
      h2.className='keyword-title';
      h2.textContent='Popular Topics';

      const keywords=search.querySelector('.jdgm-keywords');

      if(keywords){
        search.insertBefore(h2,keywords);
      }
    }

  });



  document.querySelectorAll('.jdgm-rev-widg__header').forEach(header=>{

    const search=header.querySelector('.jdgm-row-search');
    const sort=header.querySelector('.jdgm-rev-widg__sort-wrapper');

    if(search && sort){
      header.insertBefore(search,sort);
    }

  });



  const closeSvg = `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
  <path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"></path>
  </svg>`;


  document.querySelectorAll('.jdgm-cancel-question')
    .forEach(el=>el.innerHTML=closeSvg);

  document.querySelectorAll('.jdgm-cancel-rev')
    .forEach(el=>el.innerHTML=closeSvg);


  document.querySelectorAll('input.jdgm-submit-question')
    .forEach(el=>el.value='Send');

  document.querySelectorAll('input.jdgm-submit-rev')
    .forEach(el=>el.value='Send');

}



if(document.querySelector('.reviews_tabs')){

  judgeMeRev();

  const revElement=
    document.querySelector('.reviews_tabs')
      ?.parentElement
      ?.querySelector('.jdgm-widget_reviews');

  if(revElement){

    const observer=new MutationObserver(function(){

      observer.disconnect();

      judgeMeRev();

      observer.observe(revElement,{
        childList:true,
        subtree:true,
        attributes:true
      });

    });

    observer.observe(revElement,{
      childList:true,
      subtree:true,
      attributes:true
    });

  }

}
/* judgeme end */ 



if(document.querySelector('.tag-list-tab select')) {
  document.querySelector('.tag-list-tab select').addEventListener('change', function() {
      window.location.href = window.location.origin+this.value
  })
  const selectElement = document.querySelector("select");
  const options = [
      ...selectElement.querySelectorAll("option[value]")
  ];
  const orderedValues = [
      "/blogs/steel-blog/tagged/Dr-Paul-Henning",
      "/blogs/steel-blog/tagged/muscle-building",
      "/blogs/steel-blog/tagged/fat-loss",
      "/blogs/steel-blog/tagged/cardiovascular-health",
      "/blogs/steel-blog/tagged/health-wellness-health-hacks",
      "/blogs/steel-blog/tagged/nutrition",
      "/blogs/recipes"
  ];
  options.sort((a, b) => orderedValues.indexOf(a.value) - orderedValues.indexOf(b.value));
  selectElement.innerHTML = '<option disabled selected hidden class="hide">Filter&nbsp;By:</option>';
  options.forEach(option => selectElement.appendChild(option));
}
if(window.innerWidth > 800) {
  if ($('#revit-prods2').length > 0) {
    $('#shopify-section-template--16283679457349__featured_product_Mz8CEC').appendTo('#revit-prods2');
    $('#shopify-section-template--16283679457349__featured_product_TMaHeA').appendTo('#revit-prods2');
  }

  $('#shopify-section-template--15777756282949__featured_product4_qgAUQV').appendTo('#combo-prods1');
  $('#shopify-section-template--15777756282949__featured_product4_N67Nhz').appendTo('#combo-prods1');
  
  $('#shopify-section-template--15777756282949__538ab704-3966-4e3f-ab08-9f7029ee14d3').appendTo('#combo-prods2');
  $('#shopify-section-template--15777756282949__featured_product4_Rp73EB').appendTo('#combo-prods2');
  $('#shopify-section-template--15777756282949__307d7eec-d0db-4428-abd4-e09e732c8daa').appendTo('#combo-prods2');
  $('#shopify-section-template--15777756282949__featured_product4_wAjJzE').appendTo('#combo-prods2');
  $('#shopify-section-template--15777756282949__46131e8a-4e44-4f72-b695-c7ce5db018e9').appendTo('#combo-prods2');
  $('#shopify-section-template--15777756282949__featured_product4_Ekjzd4').appendTo('#combo-prods2');

  $('#shopify-section-template--15777756282949__featured_product_hxXcRF').appendTo('#combo-prods3');
  $('#shopify-section-template--15777756282949__679bd530-f7a3-425b-a111-36987df11006').appendTo('#combo-prods3');
  $('#shopify-section-template--15777756282949__684ccfff-e216-4630-b81a-4c053418b1fd').appendTo('#combo-prods3');
  $('#shopify-section-template--15777756282949__featured_product_UM9bJy').appendTo('#combo-prods3');
  $('#shopify-section-template--15777756282949__featured_product_K7bkjC').appendTo('#combo-prods3');
  $('#shopify-section-template--15777756282949__featured_product_7Ccwen').appendTo('#combo-prods3');
  $('#shopify-section-template--15858256183365__featured_product_JgLEJE').appendTo('#combo-prods4');
  $('#shopify-section-template--15858256183365__featured_product_tPYRqi').appendTo('#combo-prods4');
}


$(document).ready(function() {
  if($('.accordion__toggle').length > 0) {
    $('.accordion__toggle').click(function () {
      $(this).parent('.accordion__item').toggleClass('accordion__item--expanded').siblings().removeClass('accordion__item--expanded');
      $(this).next('div').slideToggle();
      $(this).parent('.accordion__item').siblings().children('.accordion__full-text').slideUp();
    })
  }
  $('.faq-q').on('click', function() {
    $(this).closest('.faq-item').siblings().find('.faq-ans').slideUp();
    $(this).next().slideToggle();
  });
  if(window.innerWidth < 800) {
    let topSpace = $('#header').height();
    $('.mobile-header-space').css('margin-top', topSpace)
  }
  if(window.innerWidth < 800) {
    $('.main-pdp .img').click(function() {
      $('.fancybox-button.fancybox-button--close').click(function(){
        $('.fancybox-button.fancybox-close-small').trigger('click');
      });
    })
  }
})



const allSections = document.querySelectorAll('.jerky-bundle-combo')
const comboContainer = document.querySelector('#combo-prods5')

allSections.forEach(section => {
  const parent = section.parentElement
  if (parent && comboContainer) {
    comboContainer.appendChild(parent)
    allSections.forEach(section => {
      section.classList.remove('hide')
    })
  }
})


const faqQuestions = document.querySelectorAll(".steel-faq-question");
faqQuestions.forEach((question) => {
  question.addEventListener("click", function () {
    this.classList.toggle("active");
    const answer = this.nextElementSibling;
    if (answer.style.maxHeight) {
      answer.style.maxHeight = null;
    } else {
      answer.style.maxHeight = answer.scrollHeight + "px";
    }
  });
});


/* gorgias icon css start */

(function () {
  const initGorgiasChatPromise = window.GorgiasChat
    ? window.GorgiasChat.init()
    : new Promise(function (resolve) {
        window.addEventListener("gorgias-widget-loaded", resolve);
      });

  initGorgiasChatPromise.then(function () {
    const timer = setInterval(function () {
      const iframe = document.querySelector(
        "#gorgias-chat-container #chat-button"
      );

      if (!iframe || !iframe.contentWindow) return;

      const iframeDoc = iframe.contentWindow.document;
      const head = iframeDoc.head;

      if (!head) return;

      clearInterval(timer);

      function updateGorgiasStyle() {
        try {
          const currentIframe = document.querySelector(
            "#gorgias-chat-container #chat-button"
          );
          if (!currentIframe || !currentIframe.contentWindow) return;
          const currentDoc = currentIframe.contentWindow.document;
          if (!currentDoc || !currentDoc.head) return;

          let style = currentDoc.getElementById("custom-gorgias-chat-style");
          if (!style) {
            style = currentDoc.createElement("style");
            style.id = "custom-gorgias-chat-style";
            currentDoc.head.appendChild(style);
          }

          const isMobile = window.innerWidth <= 768;

          let css = `
            /* Desktop + Mobile */
            #gorgias-chat-messenger-button div:first-child svg * {
              fill: white !important;
            }
            #gorgias-chat-messenger-button div:nth-child(2) svg * {
              stroke: white !important;
            }
          `;

          if (isMobile) {
            css += `
              #gorgias-chat-messenger-button {
                width: 35px !important;
                height: 35px !important;
                min-width: 35px !important;
                min-height: 35px !important;
                padding: 0 !important;
                border-radius: 50% !important;
                margin-bottom: 0 !important;
                outline: none !important;
                border-color: rgb(0, 190, 165) !important;
              }
              
              #gorgias-chat-messenger-button::focus-visible {
                outline: none !important;
                border: none !important;
              }

              #gorgias-chat-messenger-button h2,
              #gorgias-chat-messenger-button span,
              #gorgias-chat-messenger-button p,
              #gorgias-chat-messenger-button .text {
                display: none !important;
              }

              #gorgias-chat-messenger-button > div {
                left: 50% !important;
                top: 50%;
                transform: translateX(-50%) translateY(-50%) !important;
                width: 20px !important;
                position: absolute;
                height: 20px !important;
              }
            `;
          }

          style.textContent = css;
        } catch (e) {
          console.error("Error updating Gorgias chat style:", e);
        }
      }

      updateGorgiasStyle();

      window.addEventListener("resize", updateGorgiasStyle);
      window.addEventListener("orientationchange", updateGorgiasStyle);

      const mediaQuery = window.matchMedia("(max-width: 768px)");
      if (mediaQuery.addEventListener) {
        mediaQuery.addEventListener("change", updateGorgiasStyle);
      } else if (mediaQuery.addListener) {
        mediaQuery.addListener(updateGorgiasStyle);
      }
    }, 100);
  });
})();

/* gorgias icon css end */



// async function getVisitorLocation() {
//   try {
//     const response = await fetch('https://ipapi.co/json/');
//     if (!response.ok) throw new Error('Location lookup failed');
//     return await response.json();
//   } catch (error) {
//     console.error('Location error:', error);
//     return null;
//   }
// }

// getVisitorLocation().then(location => {
//   if (!location) return;

//   const blockedRegions = ['Hesse'];
//   const blockedRegionCodes = ['HE'];

//   if (
//     blockedRegions.includes(location.region) ||
//     blockedRegionCodes.includes(location.region_code)
//   ) {
//     document
//       .querySelectorAll('[data-state-restricted-purchase="true"]')
//       .forEach(element => {
//         element.classList.add('state-restricted');
//       });
//   }
// });